import { ChangeDetectionStrategy, Component, ViewEncapsulation, computed, input, output } from '@angular/core';

import { AvatarComponent, AvatarMode } from '@workbuddy/ui/components/avatar';
import type { ThreadTab } from '../../agent.types';

@Component({
  selector: 'agent-thread-tab',
  standalone: true,
  imports: [AvatarComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    '[class.active]': '$isActive()',
    '(click)': 'onActivate()',
  },
  template: `
    @if ($showUnreadIndicator()) {
      <span class="unread-dot"></span>
    }
    @if ($showLogo()) {
      <w-avatar [mode]="AvatarMode.WBLogo" [size]="16" />
    }
    @if ($icon(); as icon) {
      <i [class]="icon"></i>
    } @else {
      <span class="tab-label" [class.shimmer]="$streaming()">{{ $title() }}</span>
    }
    @if ($showCloseButton()) {
      <button class="close-btn" (click)="onClose($event)">
        <i class="fa-regular fa-xmark"></i>
      </button>
    }
  `,
  styleUrls: ['./thread.tab.component.less'],
})
export class AgentThreadTabComponent {

  public $tab = input.required<ThreadTab>({ alias: 'tab' });
  public $isActive = input<boolean>(false, { alias: 'isActive' });
  public $showUnreadIndicator = input<boolean>(false, { alias: 'showUnreadIndicator' });
  public $streaming = input<boolean>(false, { alias: 'streaming' });
  public $showLogo = input<boolean>(false, { alias: 'showLogo' });
  public $icon = input<string | null>(null, { alias: 'icon' });
  public $showCloseButton = input<boolean>(true, { alias: 'showCloseButton' });

  public activate = output<string>();
  public close = output<string>();

  protected readonly AvatarMode = AvatarMode;

  public $title = computed(() => this.$tab().title || 'Untitled chat');

  public onActivate(): void {

    this.activate.emit(this.$tab().threadId);
  }

  public onClose(event: MouseEvent): void {

    event.stopPropagation();
    this.close.emit(this.$tab().threadId);
  }
}
